import { get } from "lodash";
import { RESERVATION_COLOR } from "../constants";

/**
 * Single source of truth for the reservation card/row highlight color.
 * Callers normalize their own reservation shape into these flags before
 * calling this. Mirrors the priority order currently duplicated across
 * ReservationsList.js, ReservationsOverview.js, ReservationsCalendarHeader.js,
 * and DailyReservationsList.js (highest-priority flag wins).
 */
export const getReservationHighlightColor = ({
  hasDietary,
  isPaid,
  isPendingPayment,
  isVip,
  isWalkIn,
} = {}) => {
  if (isPendingPayment) return "#FF7F00";
  if (hasDietary) return "#D90429";
  if (isPaid) return "#1BC5BD";
  if (isWalkIn) return "#FFFFFF";
  if (isVip) return "#FFD700";
  return "#D1D3E0";
};

export const getCalendarEventProps = (reservation = {}) => {
  const {
    guest_customer,
    notes,
    order_date,
    order_time,
    partner_identifier,
    payment,
    reservation_notes,
  } = reservation;
  let parsedNotes = {};
  try {
    parsedNotes = notes
      ? typeof notes === "string"
        ? JSON.parse(notes)
        : notes
      : {};
  } catch (e) {
    // Notes is not a valid JSON, ignore for color coding
  }
  const dietary = get(parsedNotes, "dietary", []);
  const color = getReservationHighlightColor({
    isVip: partner_identifier?.level === "VIP",
    isPaid: payment?.amount > 0,
    hasDietary: dietary.length > 0,
    isPendingPayment:
      payment?.status === "pending" || payment?.status === "failed",
  });

  const eventColor = reservation_notes?.table?.isExclusive
    ? RESERVATION_COLOR
    : color;
  const eventProps = {
    title: `${guest_customer?.first_name} ${guest_customer?.last_name}`,
    start: `${order_date}T${order_time}`,
    allDay: false,
  };

  if (
    eventColor.toLowerCase() === "#fff" ||
    eventColor.toLowerCase() === "#ffffff" ||
    eventColor.toLowerCase() === "#d1d3e0"
  ) {
    eventProps.backgroundColor = eventColor;
    eventProps.borderColor = "#cccccc";
    eventProps.textColor = "#333333";
  } else {
    eventProps.color = eventColor;
  }

  eventProps.extendedProps = { reservation };

  return eventProps;
};
